import { z } from 'zod';

/**
 * §KB — Amazon'a kargo bildirimi girdi doğrulaması.
 *
 * Bu form doğrudan Amazon'a gidiyor ve müşterinin gördüğü takip numarasını
 * belirliyor. Yanlış numara, müşterinin gönderisini takip edememesi demek —
 * doğrulama bu yüzden sıkı.
 */

export const gonderiKalemiSchema = z.object({
  amazonOrderItemId: z.string().min(1),
  quantity: z.number().int().min(1).max(999),
});

export const kargoBildirimSchema = z
  .object({
    carrierCode: z.string().min(1, 'Taşıyıcı seçin').max(40),
    /** `OTHER` seçildiyse zorunlu — aşağıdaki refine kontrol ediyor. */
    carrierName: z.string().max(80).optional(),
    shippingMethod: z.string().max(80).optional(),
    trackingNumber: z.string().min(1, 'Takip numarası girin').max(60),
    /** Boşsa sunucu "şimdi" kullanıyor. */
    shipDate: z.string().optional(),
    /** Boşsa siparişin tüm kalemleri gönderiliyor. */
    items: z.array(gonderiKalemiSchema).max(100).optional(),
    /** Doluysa mevcut bildirim düzeltiliyor. */
    packageReferenceId: z.string().max(40).optional(),
  })
  .refine((v) => v.carrierCode !== 'OTHER' || (v.carrierName ?? '').trim().length > 0, {
    message: 'Taşıyıcı adını yazın',
    path: ['carrierName'],
  });

export type KargoBildirimDto = z.infer<typeof kargoBildirimSchema>;

export const kargoIzinSchema = z.object({
  enabled: z.boolean(),
});
export type KargoIzinDto = z.infer<typeof kargoIzinSchema>;
